import React from 'react';
import FirmwareFilesPanel from './FirmwareFilesPanel';
import SummaryPanel from './SummaryPanel';

const FirmwareOverview = ({ summary, firmware, firmwareStatus, onStatusChange }) => {
  if (!summary && firmware === undefined) return null;

  return (
    <>
      <SummaryPanel summary={summary} firmwareStatus={firmwareStatus} onStatusChange={onStatusChange} />
      <FirmwareFilesPanel firmware={firmware} />
    </>
  );
};

export default FirmwareOverview;
